export default "__VITE_ASSET__CwRWFtWB__"